export class Token {
  token_type: string;
  access_token: string;
  refresh_token?: string;
}
